import React, { useState } from 'react';

const LandingIntro = () => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed || sessionStorage.getItem('introDismissed') === 'true') {
    return null;
  }

  const handleDismiss = () => {
    setDismissed(true);
    sessionStorage.setItem('introDismissed', 'true');
  };

  return (
    <div className="landing-intro">
      <div className="landing-content">
        <p className="landing-question">
          Have you ever wondered why the same sunset can feel transcendent one evening
          and completely empty the next?
        </p>
        <p className="landing-description">
          Imagine every possible experience already exists — like every scene in a film
          already written onto the disc. You don't create the scenes by living them.
          You move through them. What changes is the <em>aperture</em> — the opening
          through which you receive.
        </p>
        <p className="landing-description">
          This is a model of that opening. Move the sliders. Watch your aperture change shape.
          See why the same world feels different depending on how you're configured to meet it.
        </p>
        <button className="landing-button" onClick={handleDismiss}>
          Begin Exploring
        </button>
      </div>
    </div>
  );
};

export default LandingIntro;
